import type { Request } from 'express';
import { ssrBffGet } from '../../../bff-api/bff';
import { getProductSearchHeaders } from '../../../bff-api/bloomreach-recommendation/useBloomreachSearch';
import { createServiceURLSearchParams } from '../utils/search-url-params-utils';
import type { SearchParams, SearchResult } from '../hooks/use-search';

export async function getSearchData(
    params: SearchParams,
    req?: Partial<Request>,
): Promise<SearchResult> {
    if (!params.q && !params.categoryId) {
        return {
            page: {
                total: 0,
                page: 0,
                pageSize: 24,
            },
            items: [],
            filters: {
                categories: [],
                byName: {
                    brand: [],
                    color: [],
                    size: [],
                    material: [],
                },
                byRange: {
                    price: [],
                    rating: [],
                },
            },
            querySuggestions: [],
            sort_fields: [],
        };
    }
    const searchParams = createServiceURLSearchParams(params);

    return ssrBffGet<SearchResult>('/bloomreach/product-search', {
        httpParams: Array.from(searchParams).map(([key, value]) => ({
            [key]: value,
        })),
        headers: getProductSearchHeaders(req),
    });
}
